<template>
  <div ref="createModal" class="modal fade" id="modal-coupon-restore" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Восстановление купона</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <template v-if="isNotLoad()">
            <div class="col-12">
              <p class="center color-red">
                Вы действительно хотите восстановить купон?
              </p>
              <div class="card">
                <div class="card-body">
                  <div class="mb-4">
                    <h3 class="card-title">{{ fields.couponName}} </h3>
                    <p class="card-subtitle">{{ fields.couponDescr }} </p>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <h3 class="card-title">Промокод:</h3>
                      <div class="card-subtitle">
                        <template v-if="fields.couponPromocode">
                          {{ fields.couponPromocode }}
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <h3 class="card-title">Дата начала:</h3>
                      <div class="card-subtitle">
                        <template v-if="fields.couponDateStart">
                          {{ fields.couponDateStart }}
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <h3 class="card-title">PromoLink:</h3>
                      <div class="card-subtitle">
                        <template v-if="fields.couponPromolink">
                          <a :href="fields.couponPromolink" target="_blank">Ссылка</a>
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <h3 class="card-title">Дата сгорания:</h3>
                      <div class="card-subtitle">
                        <template v-if="fields.couponDateEnd">
                          {{ fields.couponDateEnd }}
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <h3 class="card-title">GoToLink:</h3>
                      <div class="card-subtitle">
                        <template v-if="fields.couponGotolink">
                          <a :href="fields.couponGotolink" target="_blank">Ссылка</a>
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <h3 class="card-title">Источник:</h3>
                      <p class="card-subtitle">
                        <template v-if="fields.sourceName">
                          <img class="img-round" width="24" :src="fields.sourceImage">
                          <span>{{ fields.sourceName }}</span>
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <h3 class="card-title">Рейтинг:</h3>
                      <div class="card-subtitle">
                        <template v-if="fields.couponRating > 0">
                          {{ fields.couponRating }}
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <h3 class="card-title">Магазин:</h3>
                      <p class="card-subtitle">
                        <template v-if="fields.shopName">
                          <img class="img-round" width="24" :src="fields.shopImage">
                          <span>{{ fields.shopName }}</span>
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <h3 class="card-title">Скидка:</h3>
                      <div class="card-subtitle">
                        <template v-if="fields.couponDiscount > 0">
                          {{ fields.couponDiscount }}
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="d-flex justify-content-center">
              <div class="spinner-border"></div>
            </div>
          </template>
        </div>
        <template v-if="isNotLoad()">
          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal" @click="hide">
              Закрыть
            </button>
            <button class="btn btn-success ms-auto" @click="send">
              <IconRestore/>
              Восстановить
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {reactive, ref, onMounted, defineComponent} from 'vue'
import ApiCoupon from "@/modules/promocodes/pages/coupons/services/Api"
import IconRestore from '@/assets/icons/IconRestore'
import DTBackend from "@/services/DTBackend"
import Image from "@/services/Image"

export default defineComponent({
  name: "CouponRestore",
  components: {
    IconRestore,
  },
  setup(props, {emit}) {
    const createModal = ref(null)
    const fields = reactive(getFields())

    let load = ref(false)
    let bootModal = null

    function isNotLoad() {
      return load.value === false
    }

    function markLoad() {
      return load.value = true
    }

    function markUnload() {
      return load.value = false
    }

    function preShowModal() {
      markLoad()
    }

    function showModal(event) {
      const button = event.relatedTarget
      const couponId = button.getAttribute('data-coupon-id')
      const sourceId = button.getAttribute('data-source-id')

      ApiCoupon.item(couponId, sourceId
      ).then((resp) => {
        let item = resp.data.data
        setFields(item)
      }).catch(() => {})
      .finally(() => {
        markUnload()
      })
    }

    onMounted(() => {
      bootModal = new bootstrap.Modal(createModal.value, {
        backdrop: 'static',
        keyboard: false,
      })

      createModal.value.addEventListener('click', function (e) {
        if (e.target === createModal.value) {
          const shouldClose = confirm("Закрыть окно?")
          if (shouldClose) {
            bootModal.hide();
          }
        }
      })

      createModal.value.addEventListener('shown.bs.modal', showModal);
      createModal.value.addEventListener('show.bs.modal', preShowModal);
    })

    function getFields() {
      return {
        couponId: 0,
        shopId: 0,
        shopName: '',
        shopImage: '',
        sourceId: 0,
        sourceName: '',
        sourceImage: '',
        couponName: '',
        couponDescr: '',
        hasPromo: false,
        couponPromocode: '',
        couponPromolink: '',
        couponGotolink: '',
        couponDateStart: '',
        couponDateEnd: '',
        couponRating: 0,
        couponDiscount: '',
      }
    }

    function getSourceImage(sourceId) {
        let sourceImage = ""

        switch (sourceId) {
          case 1: sourceImage = "/assets/static/sources/admitad.svg"
          break
          case 2: sourceImage = "/assets/static/sources/advcake.svg"
          break
        }
        return sourceImage
    }

    function getShopImage(host, name) {

        if (host && name) {
          return Image.handle(host, name, 24, 24)
        } else {
          return ""
        }
    }

    function getDate(date) {
      if (!date) {
        return ""
      }
      let result, dt

      dt = new DTBackend(date)
      result = dt.get("%D.%M.%y %H:%I")

      return result
    }

    function setFields(item) {
      fields.couponId = item["coupon_id"] || 0
      fields.shopId = item["shop_id"] || 0
      fields.shopName = item["shop_name"] || ""
      fields.shopImage = getShopImage(item["shop_image_host"], item["shop_image_name"])
      fields.sourceId = item["source_id"] || 0
      fields.sourceName = item["source_name"] || ""
      fields.sourceImage = getSourceImage(item["source_id"])
      fields.couponName = item["coupon_name"] || ""
      fields.couponDescr = item["coupon_descr"] || ""
      fields.hasPromo = item["coupon_promocode"] !== ""
      fields.couponPromocode = item["coupon_promocode"] || ""
      fields.couponPromolink = item["coupon_promolink"] || ""
      fields.couponGotolink = item["coupon_gotolink"] || ""
      fields.couponDateStart = getDate(item["coupon_date_start"])
      fields.couponDateEnd = getDate(item["coupon_date_end"])
      fields.couponRating = item["coupon_rating"] || 0
      fields.couponDiscount = item["coupon_discount"] || ""
    }

    function hide() {
      bootModal.hide()
    }

    function send() {
      emit("onCouponRestore", fields.couponId, fields.sourceId)
      bootModal.hide()
    }

    return {
      createModal,
      fields,
      hide,
      send,
      isNotLoad,
    }
  }
})
</script>
